import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class SmartCardLogin extends AbstractRequestTask {

    getHeaders() {
        return {};
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");

      return `${http}${url}/services/user/smartcardlogin`;
    }

    getParams() {
      const params = super.getParams();
      const smartcard = Device.getDevice().getConfig().smartcardId;

      return Object.assign({}, params, { smartcard });
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
}

export default SmartCardLogin;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/SmartCardLoginTask.js